import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import link from './link.js';
var schema = defineObject('labeledLink', {
    label: {
        title: 'Label',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    link: {
        title: 'Link',
        type: 'link',
        validation: function validation(Rule) {
            return Rule.required();
        }
    }
}, [
    link.schema.link
]);
var validator = z.object({
    _type: z.literal('labeledLink'),
    label: z.string().optional(),
    link: link.validator.optional()
});
schema.labeledLink;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=labeledLink.js.map